'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';

/**
 * Keeps CSS viewport variables in sync with the visual viewport.
 * This is required on iOS Safari where the keyboard can shrink/offset
 * the visible viewport without updating static vh-based layouts.
 */
export function useViewportHeightVars() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  useEffect(_temp, t0);
}
function _temp() {
  if (typeof window === "undefined") {
    return;
  }
  const root = document.documentElement;
  let rafId = null;
  const applyViewportVars = () => {
    const viewport = window.visualViewport;
    const height = Math.round(viewport?.height ?? window.innerHeight);
    const width = Math.round(viewport?.width ?? window.innerWidth);
    const offsetTop = Math.round(viewport?.offsetTop ?? 0);
    const keyboardInset = Math.max(0, Math.round(window.innerHeight - ((viewport?.height ?? window.innerHeight) + offsetTop)));
    root.style.setProperty("--app-viewport-height", `${height}px`);
    root.style.setProperty("--app-viewport-width", `${width}px`);
    root.style.setProperty("--app-viewport-offset-top", `${offsetTop}px`);
    root.style.setProperty("--app-keyboard-inset", `${keyboardInset}px`);
  };
  const scheduleUpdate = () => {
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
    }
    rafId = window.requestAnimationFrame(() => {
      applyViewportVars();
      rafId = null;
    });
  };
  scheduleUpdate();
  window.addEventListener("resize", scheduleUpdate);
  window.addEventListener("orientationchange", scheduleUpdate);
  window.visualViewport?.addEventListener("resize", scheduleUpdate);
  window.visualViewport?.addEventListener("scroll", scheduleUpdate);
  return () => {
    if (rafId !== null) {
      cancelAnimationFrame(rafId);
    }
    window.removeEventListener("resize", scheduleUpdate);
    window.removeEventListener("orientationchange", scheduleUpdate);
    window.visualViewport?.removeEventListener("resize", scheduleUpdate);
    window.visualViewport?.removeEventListener("scroll", scheduleUpdate);
  };
}